<template>
    <div class="search-preferences-new__collapse">
        <div
            class="search-preferences-new__collapse__label"
            @click="proxyValue = !proxyValue"
        >
            <PtIcon :icon="proxyValue ? 'SolidDropdownOpen' : 'SolidDropdownRight'" />
            <slot name="label" />
        </div>
        <div
            v-show="proxyValue"
            class="search-preferences-new__collapse__content"
        >
            <slot />
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import { SyncValueProxyMixin } from '../mixins';

export default {
    components: {
        PtIcon,
    },
    mixins: [
        SyncValueProxyMixin(
            {
                prop: {
                    type: Boolean,
                    default: false,
                    required: true,
                },
            },
        ),
    ],
};
</script>
